import { render } from "./TestPopupPage.vue?vue&type=template&id=4ae32184"
import script from "./TestPopupPage.vue?vue&type=script&lang=js"
export * from "./TestPopupPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__